import React, { useEffect, useRef, useState } from "react";
import useClickOutside from "../../../hooks/useClickOutside";
import searchIcon from '../../lms-shared/assests/UI/searchIcon.png'
import grayImgIcon from '../../lms-shared/assests/UI/graySearchIcon.png'
import classes from './SearchApi.module.css'

const SearchApi = ({ onClickIcon, changeSearchText, inputPlaceholder, inputValue, setInputValue, listSelect, selectItemClick, showListByParams, setListSelect, imgItemListIcon }) => {

    const searchGuide = useRef()
    const interval = React.useRef(null);

    useClickOutside(searchGuide, () => {
        setListSelect([])
    });


    function myIntervalFunc(value) {
        interval.current = setTimeout(() => {
            changeSearchText(value)
        }, 1000);
    }

    function changeSearchFunc(value) {
        setInputValue && setInputValue(value ? value : null)
        clearTimeout(interval.current);
        interval.current = null
        if (value)

            myIntervalFunc(value)

    }

    function selectItemFunc(value) {
        clearTimeout(interval.current);
        interval.current = null
        selectItemClick(value)
    }

    return (
        <div className={classes.SearchContainer}>
            <img src={inputValue === null ? grayImgIcon : searchIcon} className={classes.SearchImg} style={{ cursor: inputValue === null ? "not-allowed" : "pointer" }} onClick={(e) => inputValue !== null ? onClickIcon(e) : ''} />
            <input className={classes.Search} placeholder={inputPlaceholder} value={inputValue} onChange={(e) => changeSearchFunc(e.target.value)} />

            {listSelect && listSelect.length > 0 && <div ref={searchGuide} className={classes.ListContainer}>
                {listSelect.map((s, index) =>
                    <div key={index} className={classes.TextContainer} onClick={() => s.id !== -1 && selectItemFunc(s)}>
                        {s.id !== -1 ? // ResultsFound
                            <p className={classes.Text}>
                                {showListByParams?.map((param, index) => s[param] && s[param] + `${index + 1 === (showListByParams.length - 1) ? ", " : " "}`)}
                            </p> :
                            <p className={`${classes.Text} ${classes.NoResultsFound}`}>
                                {s.name}
                            </p>
                        }
                        {imgItemListIcon && <img src={imgItemListIcon} className={classes.SearchItemIcon} />}
                    </div>)}
            </div>}
        </div >
    )
}

export default SearchApi;